import { Component, OnInit, OnDestroy, ViewChild, Input, SimpleChange } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { Pregunta } from '../_models/pregunta.model';
import { Respuesta } from '../_models/respuesta.model';
import { Solucion } from '../_models/solucion.model';

import { EvidenciasService } from '../_services/evidencias.service';
import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

declare var jQuery: any;

@Component({
  selector: 'formulariorespuestas',
  templateUrl: 'formulariorespuestas.template.html',
  //providers:  [PreguntasService]
})
export class FormularioRespuestasComponent  implements OnInit, OnDestroy {

  @ViewChild('staticModalRespuesta') staticModalRespuesta;

  @Input() idpregunta: any;

  subscription: Subscription;

  public filterQuery = "";
  public filterQueryEvidencias = "";

  primerapregunta: number = 0;

  pregunta: Pregunta;
  id_pregunta: number;

  listarespuestas : Array<Respuesta> = [];
  listaevidencias: any = [];
  listaevidenciasseleccionadas: any = [];

  resp: Respuesta;


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private globalEventsManager: GlobalEventsManager,
              private evidenciasService: EvidenciasService,
              private activatedRoute: ActivatedRoute){

      this.pregunta = new Pregunta();

  }

  ngOnInit(){
    this.getListaEvidencias();
  }

  ngOnDestroy(){

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['idpregunta']){
      this.id_pregunta = changes['idpregunta'].currentValue;
    }

    this.getPregunta(this.id_pregunta);
    this.resp = new Respuesta();

  }

  getListaEvidencias() {
    this.evidenciasService.getListaEvidenciasNorma(0).subscribe(
        data => {
          if (data){
            console.log(data.json());
            this.listaevidencias = data.json().lista;
          }
        }
    );
  }

  getPregunta(id_pregunta: number){

    this.pregunta = new Pregunta();

  }

  onSubmit(formulario: NgForm, event: Event){
    event.preventDefault;
    console.log(formulario);
  }

  anadirSolucion(i: number){
    let solucion = new Solucion();

    solucion.id_respuesta = i;

    //this.pregunta.respuestas[i].listasoluciones.push(solucion);
  }

  verModal(){
    this.staticModalRespuesta.show();
  }

  anadirEvidencia(evidencia: any, event: any){

    let encontrado: number;

    if (jQuery('#check_'+event).is(':checked')) {
      this.listaevidenciasseleccionadas.push(evidencia);
    }else{
      for (let i = 0; i < this.listaevidenciasseleccionadas.length; i++) {
        if (this.listaevidenciasseleccionadas[i].id_evidencia == evidencia.id_evidencia){

          encontrado = i;
        }

      }

      this.listaevidenciasseleccionadas.splice(encontrado,1);
    }


    console.log(this.listaevidenciasseleccionadas);
  }

}



// WEBPACK FOOTER //
// ./src/app/cuestionario/formulariorespuestas.component.ts